'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _BenchmarkChart = require('./BenchmarkChart.css');

var _BenchmarkChart2 = _interopRequireDefault(_BenchmarkChart);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactChartjs = require('react-chartjs');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chart = (_dec = (0, _reactCssModules2.default)(_BenchmarkChart2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chart, _Component);

  function Chart(props) {
    (0, _classCallCheck3.default)(this, Chart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Chart.__proto__ || (0, _getPrototypeOf2.default)(Chart)).call(this, props));

    _this.getRisk = function (val, label) {
      var riskOptions = {
        low: {
          label: 'LOW',
          styleName: 'low',
          color: '#149A43'
        },
        avg: {
          label: 'BELOW MEDIAN',
          styleName: 'avg',
          color: '#AAD797'
        },
        high: {
          label: 'ABOVE MEDIAN',
          styleName: 'high',
          color: '#DFB553'
        },
        veryHigh: {
          label: 'HIGH',
          styleName: 'very-high',
          color: '#DE450A'
        },
        extreme: {
          label: 'VERY HIGH',
          styleName: 'extreme',
          color: '#C3001C'
        }
      };
      var f = _convert2.default.float(val);
      var ranges = _config2.default.footprintRanges[label];
      if (f <= ranges.low) {
        return riskOptions.low;
      } else if (f <= ranges.avg) {
        return riskOptions.avg;
      } else if (f <= ranges.high) {
        return riskOptions.high;
      } else if (f <= ranges.veryHigh) {
        return riskOptions.veryHigh;
      } else {
        return riskOptions.extreme;
      }
    };

    _this.clickViewTooltipFootprint = function () {
      _this.setState({ viewTooltipFootprint: !_this.state.viewTooltipFootprint });
    };

    _this.clickViewTooltipIntensity = function () {
      _this.setState({ viewTooltipIntensity: !_this.state.viewTooltipIntensity });
    };

    _this.clickExpandedBenchmarkSwitch = function () {
      _this.setState({ expandedBenchmarkSwitch: !_this.state.expandedBenchmarkSwitch });
    };

    _this.clickCloseTooltips = function () {
      _this.setState({
        viewTooltipFootprint: false,
        viewTooltipIntensity: false
      });
    };

    _this.buildChartData = function (benchmarks, riskFootprint, riskIntensity) {
      var riskColorFootprint = riskFootprint.color;
      var riskColorIntensity = riskIntensity.color;
      var chartGray = '#D5D5D5';

      var datapoints = benchmarks.map(function (benchmark) {
        return [chartGray, Math.round(_convert2.default.float(benchmark.footprint)), chartGray, Math.round(_convert2.default.float(benchmark.intensity)), benchmark.name];
      });

      datapoints.push([riskColorFootprint, Math.round(_convert2.default.float(_this.props.fund.usd_relative_footprint)), riskColorIntensity, Math.round(_convert2.default.float(_this.props.fund.portfolio_carbon_carbon_intensity)), 'This fund']);

      // helper to sort
      function sortByIdx(array, idx) {
        return array.sort(function (a, b) {
          return a[idx] - b[idx];
        });
      }
      var sortedByFootprint = sortByIdx(datapoints.slice(0), 1);
      var sortedByIntensity = sortByIdx(datapoints.slice(0), 3);

      // helper for unzipping
      function getFields(input, field) {
        var output = [];
        for (var i = 0; i < input.length; ++i) {
          output.push(input[i][field]);
        }
        return output;
      }

      // unzip sorted elements
      var colorsFootprint = getFields(sortedByFootprint, 0);
      var valuesFootprint = getFields(sortedByFootprint, 1);
      var labelsFootprint = getFields(sortedByFootprint, 4);

      var colorsIntensity = getFields(sortedByIntensity, 2);
      var valuesIntensity = getFields(sortedByIntensity, 3);
      var labelsIntensity = getFields(sortedByIntensity, 4);

      return {
        chartDataFoot: {
          labels: labelsFootprint,
          datasets: [{ label: 'Relative Carbon Footprint',
            fillColor: colorsFootprint,
            strokeColor: colorsFootprint,
            highlightFill: colorsFootprint,
            highlightStroke: colorsFootprint,
            data: valuesFootprint }]
        },
        chartDataIntensity: {
          labels: labelsIntensity,
          datasets: [{ label: 'Relative Carbon Footprint',
            fillColor: colorsIntensity,
            strokeColor: colorsIntensity,
            highlightFill: colorsIntensity,
            highlightStroke: colorsIntensity,
            data: valuesIntensity }]
        }
      };
    };

    _this.state = {
      viewTooltipFootprint: false,
      viewTooltipIntensity: false,
      expandedBenchmarkSwitch: false
    };
    return _this;
  }

  (0, _createClass3.default)(Chart, [{
    key: 'render',
    value: function render() {
      var _getRisk = this.getRisk;

      var chartOptionsFoot = {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scaleShowLabels: true,
        scaleShowGridLines: true,
        scaleShowVerticalLines: false,
        scaleShowHorizontalLines: true,
        showScale: true,
        scaleStartValue: 0
      };

      var chartOptionsIntensity = {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scaleShowLabels: true,
        scaleShowGridLines: true,
        scaleShowVerticalLines: false,
        scaleShowHorizontalLines: true,
        showScale: true,
        scaleStartValue: 0
      };

      var riskFootprint = _getRisk(this.props.fund.usd_relative_footprint, 'footprint');
      var riskIntensity = _getRisk(this.props.fund.portfolio_carbon_carbon_intensity, 'intensity');

      var isExpanded = this.state.expandedBenchmarkSwitch;

      var coreBenchmarksArray = _config2.default.coreBenchmarks;
      var fullBenchmarksArray = _config2.default.coreBenchmarks.concat(_config2.default.extendedBenchmarks);

      function renderFootprintRisk(f) {
        var risk = _getRisk(f, 'footprint');
        var riskLabel = risk.label;
        var riskStyle = risk.styleName;
        return _react2.default.createElement(
          'span',
          { styleName: riskStyle },
          _react2.default.createElement(
            'span',
            null,
            riskLabel,
            ' compared to benchmarks'
          )
        );
      }
      function renderFootprintNumberbox(f) {
        var risk = _getRisk(f, 'footprint');
        var riskStyle = risk.styleName;
        return _react2.default.createElement(
          'div',
          { styleName: 'benchmark-chart-header-numberbox-' + riskStyle },
          _react2.default.createElement(
            'div',
            { styleName: 'benchmark-chart-header-numberbox-header' },
            'Relative carbon footprint'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'benchmark-chart-header-numberbox-figure-' + riskStyle },
            _format2.default.number(f)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'benchmark-chart-header-numberbox-label' },
            'tonnes CO',
            _react2.default.createElement(
              'sub',
              null,
              '2'
            ),
            ' / $1M USD invested'
          )
        );
      }
      function renderIntensityRisk(f) {
        var risk = _getRisk(f, 'intensity');
        var riskLabel = risk.label;
        var riskStyle = risk.styleName;
        return _react2.default.createElement(
          'span',
          { styleName: riskStyle },
          _react2.default.createElement(
            'span',
            null,
            riskLabel,
            ' compared to benchmarks'
          )
        );
      }
      function renderIntensityNumberbox(f) {
        var risk = _getRisk(f, 'intensity');
        var riskStyle = risk.styleName;
        return _react2.default.createElement(
          'div',
          { styleName: 'benchmark-chart-header-numberbox-' + riskStyle },
          _react2.default.createElement(
            'div',
            { styleName: 'benchmark-chart-header-numberbox-header' },
            'Relative carbon intensity'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'benchmark-chart-header-numberbox-figure-' + riskStyle },
            _format2.default.number(f)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'benchmark-chart-header-numberbox-label' },
            'tonnes CO',
            _react2.default.createElement(
              'sub',
              null,
              '2'
            ),
            ' / $1M USD revenue'
          )
        );
      }
      function renderBenchmarkTooltipText(label, plural) {
        return _react2.default.createElement(
          'div',
          null,
          'Funds are compared to 20 of the most common investment indexes from major index providers like MSCI, FTSE/Russell, S&P, and Morningstar. Click the "Show all benchmarks" switch to show all 20 benchmarks in the charts below. Using iShares index ETFs as a stand-in for each index, we calculate the carbon ',
          label,
          ' and divide the benchmarks into quartiles, labeled ',
          _react2.default.createElement(
            'strong',
            { styleName: 'low' },
            'low'
          ),
          ', ',
          _react2.default.createElement(
            'strong',
            { styleName: 'avg' },
            'below median'
          ),
          ', ',
          _react2.default.createElement(
            'strong',
            { styleName: 'high' },
            'above median'
          ),
          ', and ',
          _react2.default.createElement(
            'strong',
            { styleName: 'very-high' },
            'high'
          ),
          '. The carbon ',
          label,
          ' of the fund is compared to these benchmark quartiles. If the ',
          label,
          ' is higher than all 20 benchmarks, it is labeled ',
          _react2.default.createElement(
            'strong',
            { styleName: 'extreme' },
            'very high'
          ),
          '. The benchmark quartiles are recalculated each month.'
        );
      }

      var footprintTableItems = [].concat(fullBenchmarksArray).sort(function (a, b) {
        return a.footprint - b.footprint;
      }).map(function (item, idx) {
        var risk = _getRisk(item.footprint, 'footprint');
        var riskLabel = risk.label;
        var riskStyle = risk.styleName;
        return _react2.default.createElement(
          'tr',
          { styleName: 'benchmark-tooltip-table-item', key: idx },
          _react2.default.createElement(
            'td',
            null,
            item.name
          ),
          _react2.default.createElement(
            'td',
            { styleName: riskStyle },
            _format2.default.number(item.footprint, true, true),
            ' \u2014 ',
            riskLabel
          )
        );
      });

      var intensityTableItems = [].concat(fullBenchmarksArray).sort(function (a, b) {
        return a.intensity - b.intensity;
      }).map(function (item, idx) {
        var risk = _getRisk(item.intensity, 'intensity');
        var riskLabel = risk.label;
        var riskStyle = risk.styleName;
        return _react2.default.createElement(
          'tr',
          { styleName: 'benchmark-tooltip-table-item', key: idx },
          _react2.default.createElement(
            'td',
            null,
            item.name
          ),
          _react2.default.createElement(
            'td',
            { styleName: riskStyle },
            _format2.default.number(item.intensity, true, true),
            ' \u2014 ',
            riskLabel
          )
        );
      });

      return _react2.default.createElement(
        'div',
        { styleName: 'benchmark-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'benchmark-wrap-inner' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 4, styleName: 'chart-sidebar-wrap' },
              renderFootprintNumberbox(this.props.fund.usd_relative_footprint)
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 8, styleName: 'main-content-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-header' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'benchmark-chart-header-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-title' },
                    'Carbon footprint ',
                    _react2.default.createElement(_.XsBr, null),
                    _react2.default.createElement(
                      'small',
                      null,
                      _react2.default.createElement(
                        'i',
                        null,
                        'emissions per unit of investment'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-subtitle' },
                    renderFootprintRisk(this.props.fund.usd_relative_footprint)
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-info' },
                    'Expresses the greenhouse gas footprint of an investment sum. Relative carbon footprint is measured in metric tonnes of CO',
                    _react2.default.createElement(
                      'sub',
                      null,
                      '2'
                    ),
                    ' or CO',
                    _react2.default.createElement(
                      'sub',
                      null,
                      '2'
                    ),
                    ' equivalents per $1 million USD invested. A fund\'s carbon footprint accounts for direct and indirect (scope 1 and 2) emissions.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 0, sm: 1 }),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 10 },
              _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-options' },
                _react2.default.createElement(
                  'div',
                  {
                    styleName: 'benchmark-chart-notice',
                    onClick: this.clickViewTooltipFootprint,
                    title: 'How do we compare funds to benchmarks?' },
                  _react2.default.createElement('i', { className: 'fa fa-question-circle' }),
                  ' How do we compare funds to benchmarks?'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    styleName: 'benchmark-chart-switch',
                    onClick: this.clickExpandedBenchmarkSwitch,
                    title: 'Show all benchmarks switch' },
                  'Show all benchmarks\xA0',
                  isExpanded ? _react2.default.createElement('i', { className: 'fa fa-toggle-on fa-2x' }) : _react2.default.createElement('i', { className: 'fa fa-toggle-off fa-2x' })
                )
              ),
              this.state.viewTooltipFootprint ? _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-tooltip-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'benchmark-chart-tooltip-wrap-inner' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-tooltip' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'benchmark-tooltip-close', title: 'Close',
                        onClick: this.clickViewTooltipFootprint },
                      'Close',
                      _react2.default.createElement(_.LinkIcon, { faclass: 'fa-times' })
                    ),
                    renderBenchmarkTooltipText('footprint', 'footprints'),
                    _react2.default.createElement(
                      'table',
                      { styleName: 'benchmark-tooltip-table' },
                      footprintTableItems,
                      _react2.default.createElement(
                        'tr',
                        { styleName: 'benchmark-tooltip-table-item benchmark-tooltip-table-last' },
                        _react2.default.createElement(
                          'td',
                          null,
                          'THIS FUND: ',
                          this.props.fund.fund_legal_name
                        ),
                        _react2.default.createElement(
                          'td',
                          { styleName: riskFootprint.styleName },
                          _format2.default.number(this.props.fund.usd_relative_footprint, true, true),
                          ' \u2014 ',
                          riskFootprint.label
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      'Relative carbon footprint is measured in metric tonnes of CO',
                      _react2.default.createElement(
                        'sub',
                        null,
                        '2'
                      ),
                      ' or CO',
                      _react2.default.createElement(
                        'sub',
                        null,
                        '2'
                      ),
                      ' equivalents per $1 million USD invested, Scope 1 + 2'
                    )
                  )
                )
              ) : null,
              _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-chart-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'benchmark-chart-chart' },
                  isExpanded ? _react2.default.createElement(_reactChartjs.Bar, {
                    data: this.buildChartData(fullBenchmarksArray, riskFootprint, riskIntensity).chartDataFoot,
                    options: chartOptionsFoot }) : null,
                  !isExpanded ? _react2.default.createElement(_reactChartjs.Bar, {
                    data: this.buildChartData(coreBenchmarksArray, riskFootprint, riskIntensity).chartDataFoot,
                    options: chartOptionsFoot }) : null
                )
              )
            ),
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 0, sm: 1 })
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'intensity-row' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 4, styleName: 'chart-sidebar-wrap' },
              renderIntensityNumberbox(this.props.fund.portfolio_carbon_carbon_intensity)
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 12, md: 8, styleName: 'main-content-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-header' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'benchmark-chart-header-info' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-title' },
                    'Carbon intensity ',
                    _react2.default.createElement(_.XsBr, null),
                    _react2.default.createElement(
                      'small',
                      null,
                      _react2.default.createElement(
                        'i',
                        null,
                        'emissions per unit of revenue'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-subtitle' },
                    renderIntensityRisk(this.props.fund.portfolio_carbon_carbon_intensity)
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-info' },
                    'Expresses the carbon efficiency of a portfolio. Relative carbon intensity is measured in metric tonnes of CO',
                    _react2.default.createElement(
                      'sub',
                      null,
                      '2'
                    ),
                    ' or CO',
                    _react2.default.createElement(
                      'sub',
                      null,
                      '2'
                    ),
                    ' equivalents per $1 million USD revenue. A fund\'s carbon intensity accounts for direct and indirect (scope 1 and 2) emissions.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 0, sm: 1 }),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 10 },
              _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-options' },
                _react2.default.createElement(
                  'div',
                  {
                    styleName: 'benchmark-chart-notice',
                    onClick: this.clickViewTooltipIntensity,
                    title: 'How do we compare funds to benchmarks?' },
                  _react2.default.createElement('i', { className: 'fa fa-question-circle' }),
                  ' How do we compare funds to benchmarks?'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    styleName: 'benchmark-chart-switch',
                    onClick: this.clickExpandedBenchmarkSwitch,
                    title: 'Show all benchmarks switch' },
                  'Show all benchmarks\xA0',
                  isExpanded ? _react2.default.createElement('i', { className: 'fa fa-toggle-on fa-2x' }) : _react2.default.createElement('i', { className: 'fa fa-toggle-off fa-2x' })
                )
              ),
              this.state.viewTooltipIntensity ? _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-tooltip-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'benchmark-chart-tooltip-wrap-inner' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'benchmark-chart-tooltip' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'benchmark-tooltip-close',
                        onClick: this.clickViewTooltipIntensity, title: 'Close' },
                      'Close',
                      _react2.default.createElement(_.LinkIcon, { faclass: 'fa-times' })
                    ),
                    renderBenchmarkTooltipText('intensity', 'intensities'),
                    _react2.default.createElement(
                      'table',
                      { styleName: 'benchmark-tooltip-table' },
                      intensityTableItems,
                      _react2.default.createElement(
                        'tr',
                        { styleName: 'benchmark-tooltip-table-item benchmark-tooltip-table-last' },
                        _react2.default.createElement(
                          'td',
                          null,
                          'THIS FUND: ',
                          this.props.fund.fund_legal_name
                        ),
                        _react2.default.createElement(
                          'td',
                          { styleName: riskIntensity.styleName },
                          _format2.default.number(this.props.fund.portfolio_carbon_carbon_intensity, true, true),
                          ' \u2014 ',
                          riskIntensity.label
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      'Relative carbon intensity is measured in metric tonnes of CO',
                      _react2.default.createElement(
                        'sub',
                        null,
                        '2'
                      ),
                      ' or CO',
                      _react2.default.createElement(
                        'sub',
                        null,
                        '2'
                      ),
                      ' equivalents per $1 million USD revenue, Scope 1 + 2'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'benchmark-tooltip-close',
                        onClick: this.clickViewTooltipIntensity, title: 'Close' },
                      'Close',
                      _react2.default.createElement(_.LinkIcon, { faclass: 'fa-times' })
                    )
                  )
                )
              ) : null,
              _react2.default.createElement(
                'div',
                { styleName: 'benchmark-chart-chart-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'benchmark-chart-chart' },
                  isExpanded ? _react2.default.createElement(_reactChartjs.Bar, {
                    data: this.buildChartData(fullBenchmarksArray, riskFootprint, riskIntensity).chartDataIntensity,
                    options: chartOptionsIntensity }) : null,
                  !isExpanded ? _react2.default.createElement(_reactChartjs.Bar, {
                    data: this.buildChartData(coreBenchmarksArray, riskFootprint, riskIntensity).chartDataIntensity,
                    options: chartOptionsIntensity }) : null
                )
              )
            ),
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 0, sm: 1 })
          )
        ),
        this.state.viewTooltipFootprint || this.state.viewTooltipIntensity ? _react2.default.createElement('div', { styleName: 'tooltip-overlay', onClick: this.clickCloseTooltips }) : null
      );
    }
  }]);
  return Chart;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = Chart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BenchmarkChart/BenchmarkChart.js
// module id = 1367
// module chunks = 0